import React, {Component} from "react";
import { withRouter } from "../../helpers/withRouter";
import Study from "../../core/api/Study2/Study";
import config from "../../config";
import User from "../../core/api/User2/User";
import ACTION_TITLES from "../../core/constants/Actions";
import "./Viewer.scss";
import "./ViewerPlusReport.scss"
import Storage from "../../helpers/Storage";
import T from "../../shared/component/t/T"
import snippets from "../../helpers/snippets";
import {connect} from "react-redux";
import { default as _ } from '../../helpers/Translate';
import ReportOrViewer from "../Reports/report/ReportOrViewer";
import ErrorComponent from "../../shared/component/ErrorComponent/ErrorComponent";

const study = new Study();
const userLog = new User();

class Viewer extends Component {
  QUICK_MODE = "quick";
  ADVANCED_MODE = "advanced";

  constructor(props) {
    super(props);

    this.timeout = 0;

    this.state = {
      language: this.props.language,
      device: this.props.device,
      viewLink: null,
      userLogID: null,
      storageData: Storage.getAllAsObject(),
      data: {},
      canShowReport: false,
      showViewer: true,
      showReport: Storage.splitViewGet(),
      panelSize: window.innerWidth/2,
	  isDragging: false
    };

    this.iframeRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.language !== this.props.language) {
      this.setState({language: this.props.language});
    }
    if (prevProps.device !== this.props.device) {
      this.setState({device: this.props.device});
    }
    if (prevState.showReport !== this.state.showReport) {
      Storage.splitViewSet(this.state.showReport)
    }
    if (prevState.showViewer !== this.state.showViewer || prevState.showReport !== this.state.showReport) {
	  this.updateDivHeight()
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDivHeight)
    document.cookie = `Ticket=${Storage.getTicket()}`;

    study.studyInfoForReport(this.props.params.studyID, null, true).then(response => {
      let mode = String(this.props.params.mode).toLocaleLowerCase();
      const studyInfo = response.data.study;
      const storageId = studyInfo.storage_id;
      const fileName = `${mode}.html`;
      const resultPath = `${config.baseUrl}viewer/${fileName}?storageId=${storageId}&study=${studyInfo.id}`;
      document.title = _.init4("title_viewPage", {patient: response.data.patient?.full_name}, this.state.language)

      if (this.state.showReport && snippets.isObjectEmpty(studyInfo?.reports)) {this.setState({showReport: false})}

      this.setState({
        data: response.data,
        viewLink: resultPath,
        canShowReport: !snippets.isObjectEmpty(studyInfo?.reports),
      }, () => {
        Storage.setAllKeysAgain(this.state.storageData);
        this.handleCreateUserLog(mode,studyInfo.id, resultPath);

        // try to focus on iframe after it loads
        const iframe = this.iframeRef.current;
        if (iframe) {
          iframe.addEventListener('load', this.handleIframeLoad);
          iframe.contentWindow.displayReportBeside = () => {
            if (this.state.canShowReport && this.state.device !== "mobile" ) this.setState({showReport: !this.state.showReport})
            else alert(`${_.init("study_has_no_report")} ${_.init("or")} ${_.init("mobile_mode_not_allowed_to")}`)
          }
        }
      });
    }).catch(error => console.log(error));
  }

  componentWillUnmount() {
    //todo: send user log into server before exit
    window.removeEventListener('beforeunload', this.handleUpdateUserLog);
    window.removeEventListener('unload', this.handleUpdateUserLog);
    window.removeEventListener('resize', ()=>{})
    const iframe = this.iframeRef.current;
    if (iframe) {
      iframe.removeEventListener('load', this.handleIframeLoad);
    }
  }

  handleIframeLoad = () => {
    this.iframeRef.current?.contentWindow?.focus()
    this.updateDivHeight()
  };

  updateDivHeight = () => {
    const windowHeight = window.innerHeight;
    const viewer = document.querySelector('.report__container');
    const report = document.querySelector('.report_contents');
    if (viewer) {
      viewer.style.height = `${windowHeight}px`;
    }
    if (report && window.innerWidth >= 900) {
      report.style.height = `${windowHeight}px`;
      report.style.overflowX = `auto`;
    } else if (report) {
      report.style.minHeight = `${windowHeight}px`;
      report.style.height = `100%`
      report.style.overflowX = `hidden`;
    }
  }

  handleCreateUserLog = (mode = "", studyID, path = "") => {
    let actionID = null;

    switch(mode) {
      case this.QUICK_MODE:
        actionID = ACTION_TITLES.newQuickView.id;
        break;
      case this.ADVANCED_MODE:
        actionID = ACTION_TITLES.newAdvancedView.id;
        break;
      default:
        console.error("Wrong mode entered!!!");
    }

    userLog.userLogCreate({
      action: actionID,
      studyID: studyID,
      path: path
    }).then(response => {
      this.setState({
        userLogID: response?.data.user_log.id
      }, () => {
        window.addEventListener('beforeunload', this.handleUpdateUserLog);
        window.addEventListener('unload', this.handleUpdateUserLog);
        this.timeout = setTimeout(this.handleUpdateUserLog, 10000);
      });
    }).catch(error => console.log(error));
  }

  handleUpdateUserLog = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    userLog.userLogUpdate({
      userLogID: this.state.userLogID,
    }).then(() => {
      // Nothing to do here :)
    }).catch(error =>
        console.log(error)
    ).finally(() => {
        Storage.setAllKeysAgain(this.state.storageData);
    });
  }


  closeReport = () =>{
    this.setState({
      showReport: false,
      showViewer: true
    })
  }

  fullScreen = ()=>{
    this.setState({
      showViewer: !this.state.showViewer
    })
  }

  reportCrashed = ()=>{
    this.setState({
      showReport: false
    }, ()=>{})
  }

  handleMouseDown = (e) => {
    const startX = e.clientX;
    const startPanelWidth = this.state.panelSize;

    const onMouseMove = (e) => {
	    const newPanelWidth = startPanelWidth + (e.clientX - startX);
      this.setState({
	    isDragging: true,
        panelSize:(Math.min(window.innerWidth - 50, Math.max(50, newPanelWidth)))
      }, ()=> {});
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
	  this.setState({ isDragging: false })
	  document.body.style.userSelect = '';
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
	document.body.style.userSelect = 'none'
  };
  
  handleSize = () => {
	let reportSize, viewerSize
	if (this.state.showViewer && this.state.showReport){
		let size = Math.max(300,
			Math.min(window.innerWidth - 600, window.innerWidth - this.state.panelSize))
		reportSize = `calc(100% - ${size + 5}px)`
		viewerSize = `${size}px`
	} else if (this.state.showViewer) {
		reportSize = `0%`
		viewerSize = `100%`
	} else if (this.state.showReport) {
		reportSize = `100%`
		viewerSize = `0%`
	}
	return {reportSize, viewerSize}
  }

  handleResizer = () => {
	  let report = <div
		  className={`ViewerPlusReport_report ${!this.state.showReport ? "hidden" : this.state.showViewer ? "both" : "fullScreen"}`}>
		  {this.state.canShowReport &&
			  <ErrorComponent errorHandler={this.reportCrashed}>
				  <div className={"report_contents"}>
					  <ReportOrViewer parentComp={"split_viewer"}
					                  data={this.state.data}
					                  repID={this.props.params.reportID}
					                  closeOrFullScreen={Object.assign({},
						                  {closeFunc: () => this.closeReport()},
						                  {fullFunc: () => this.fullScreen()},
						                  {state: this.state.showViewer}
					                  )}
					  />
				  </div>
			  </ErrorComponent>
		  }
	  </div>
	  
	  let viewer = <div className={`ViewerPlusReport_viewer ${this.state.showViewer ? "" : "hidden"}`}>
		  {
			  this.state.viewLink ?
				  <div className="report__container">
					  <iframe src={this.state.viewLink}
					          ref={this.iframeRef}
					          id={"viewer_iframe"}
					          title={"viewer"}
					  />
				  </div> : <div><T token={"loading"}/></div>
		  }
	  </div>

	  if (this.state.device === 'desktop') {
		  let {reportSize, viewerSize} = this.handleSize()
		  return  <div className={'w-100 d-flex align-items-center justify-content-center '}>
            <span style={{ width: viewerSize, pointerEvents: this.state.isDragging ? 'none' : 'auto'}}>{viewer}</span>
            <span className={'my-resize'} ref={this.dividerRef} onMouseDown={this.handleMouseDown}>
                <span className={"my-resize-mover"}> <span /> </span>
            </span>
            <span style={{ width: reportSize, pointerEvents: this.state.isDragging ? 'none' : 'auto'}}>{report}</span>
          </div>
	  } else {
		  return <>{viewer}{report}</>
	  }
  }
	
	render() {
		return <span className={"ViewerPlusReport"}>
	     {this.handleResizer()}
    </span>
  }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  const device = state.DeviceModeReducer.mode
  return {language, device};
}

export default connect(mapStateToProps)(withRouter(Viewer));